import { T } from '@/lib/tokens';

interface PhotoSourceTabsProps {
  activeTab: 'upload' | 'library';
  onTabChange: (tab: 'upload' | 'library') => void;
}

export function PhotoSourceTabs({ activeTab, onTabChange }: PhotoSourceTabsProps) {
  const tabs: { key: 'upload' | 'library'; label: string }[] = [
    { key: 'upload', label: 'Upload photo' },
    { key: 'library', label: 'Choose from library' },
  ];

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onTabChange(tab.key)}
            style={{
              flex: 1,
              padding: '10px 4px',
              fontSize: 13,
              fontWeight: isActive ? 700 : 400,
              color: isActive ? T.accent : T.textMuted,
              background: 'transparent',
              border: 'none',
              borderBottomWidth: 2,
              borderBottomStyle: 'solid',
              borderBottomColor: isActive ? T.accent : 'transparent',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              fontFamily: 'inherit',
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
